import { CompanySettlementsMapper } from "@/adapters/CompanySettlements.mapper";
import { withCorpGuard } from "@/services/corp/corpGuard";
import { toB2BError, toDataShapeError } from "@/utils/b2bErrors";
import { lazyService } from "@/utils/lazyMock";
import { supabase } from "@/utils/supabase";
export class CorpSettlementsService {
    async listInvoices(companyId) {
        return withCorpGuard((async () => {
            const { data, error } = await supabase()
                .from("corp_my_invoices")
                .select("*")
                .eq("company_id", companyId)
                .order("issue_date", { ascending: false });
            if (error)
                throw toB2BError(error);
            try {
                return (data ?? []).map(CompanySettlementsMapper.invoiceToDomain);
            }
            catch (parseError) {
                throw toDataShapeError(parseError);
            }
        })());
    }
    async listInvoiceLines(companyId, invoiceId) {
        return withCorpGuard((async () => {
            const { data, error } = await supabase()
                .from("corp_my_invoice_lines")
                .select("*")
                .eq("company_id", companyId)
                .eq("invoice_id", invoiceId)
                .order("line_date");
            if (error)
                throw toB2BError(error);
            try {
                return (data ?? []).map(CompanySettlementsMapper.lineToDomain);
            }
            catch (parseError) {
                throw toDataShapeError(parseError);
            }
        })());
    }
    async listPayments(companyId) {
        return withCorpGuard((async () => {
            const { data, error } = await supabase()
                .from("corp_my_payments")
                .select("*")
                .eq("company_id", companyId)
                .order("paid_at", { ascending: false });
            if (error)
                throw toB2BError(error);
            try {
                return (data ?? []).map(CompanySettlementsMapper.paymentToDomain);
            }
            catch (parseError) {
                throw toDataShapeError(parseError);
            }
        })());
    }
    async listLedger(companyId) {
        return withCorpGuard((async () => {
            const { data, error } = await supabase()
                .from("corp_my_ledger")
                .select("*")
                .eq("company_id", companyId)
                .order("effective_at", { ascending: false });
            if (error)
                throw toB2BError(error);
            try {
                return (data ?? []).map(CompanySettlementsMapper.ledgerToDomain);
            }
            catch (parseError) {
                throw toDataShapeError(parseError);
            }
        })());
    }
}
// Литерал REACT_APP_B2B_MOCK — см. CompanyLinkService.ts / utils/lazyMock.ts (G4).
export const corpSettlementsService = process.env.REACT_APP_B2B_MOCK === "true"
    ? lazyService(() => import("@/services/corp/CorpSettlementsServiceMock").then((module) => module.corpSettlementsServiceMock))
    : new CorpSettlementsService();
